import { ApiEndpointUrl } from "../../common";
export const pagePoint = {
  content: ApiEndpointUrl + "page",
  contact: ApiEndpointUrl + "contactrequest",
  subscribe: ApiEndpointUrl + "contactsubscribe",
};